import { Routes, Route, Navigate } from 'react-router-dom';

// Páginas existentes (se mantienen igual)
import FrontSigmaKey from './components/Pages/FrontSigmaKey';
import LoginSigmaKey from './components/Pages/LoginSigmaKey';
import ForgotPassword from './components/Pages/ForgotPassword';
import ResetPassword from './components/Pages/ResetPassword';
import PanelSigmaKey from './components/Pages/PanelSigmaKey';
import Chofer from './components/CarBooking/Pages/DriverDashboard';
import RolesPage from './components/security/RolesPage';
import ModulosPage from './components/Seguridad/Components/Catalogos/Modulos/ModulosPage';
import MenusPage from './components/Seguridad/Components/Catalogos/Menus/MenusPage';
import RolesRecursosPermisosMatrix from './components/Seguridad/Components/Gestion/RolesRecursosPermisos/RolesRecursosPermisosMatrix';
import Reservation from './components/CarBooking/Pages/ReservationPage';
import Maps from './components/CarBooking/Pages/MapPickerGoogle';
import Calendar from './components/CarBooking/Pages/WeeklyCalendar';
import RHReviewPage from './components/CarBooking/Pages/RHInbox';
import ReportesReservasPage from './components/CarBooking/Components/Catalogos/ReportesReservas/ReportesReservasPage';
import ChecklistViajePage from './components/CarBooking/Components/Catalogos/ChecklistViaje/ChecklistViajePage';
import Lessons from './components/Lms/Pages/Lessons';
// Shell y subpaneles
import { SigmaShell } from './components/Pages/SigmaShell';
import DynamicCatalogPage from './components/Pages/DynamicCatalogPage';
import MainModulesPanel from './components/Pages/MainModulesPanel';
import CarBookingPanel from './components/Pages/CarBookingPanel';
import LmsPanel from './components/Pages/LmsPanel';
import IntranetPanel from './components/Pages/IntranetPanel';
import ReportesPanel from './components/Pages/ReportesPanel';
import ConfiguracionPanel from './components/Pages/ConfiguracionPanel';
import RHPanel from './components/Pages/RHPanel';
import Organigrama from './components/RH/Components/Organigrama/Organigrama';
import EstudiantesPage from './components/Lms/Components/Catalogos/Estudiantes/EstudiantesPage';
import EstadisticasPage from './components/Lms/Components/Catalogos/Estadisticas/EstadisticasPage';
import AdministrarCursosPage from './components/Lms/Components/Catalogos/AdministrarCursos/AdministrarCursosPage';
import AdministrarCarrerasPage from './components/Lms/Components/Catalogos/AdministrarCarreras/AdministrarCarrerasPage';
import ProgresoEstudiantesPage from './components/Lms/Components/Catalogos/ProgresoEstudiantes/ProgresoEstudiantesPage';
import AsignarCursosEstudiantesPage from './components/Lms/Components/Catalogos/AsignacionCursosEstudiantes/AsignarCursosEstudiantesPage';
import AsignarCursosAreaPage from './components/Lms/Components/Catalogos/AsignacionCursosArea/AsignarCursosAreaPage';
import AsignarCursosPuestoPage from './components/Lms/Components/Catalogos/AsignacionCursosPuesto/AsignarCursosPuestoPage';
import AsignarCursosTurnoPage from './components/Lms/Components/Catalogos/AsignacionCursosTurno/AsignarCursosTurnoPage';
import CarrerasPage from './components/Lms/Pages/CarrerasPage';
import SemestresPage from './components/Lms/Pages/SemestresPage';
import CursosCompartidosPage from './components/Lms/Components/Catalogos/CursosCompartidos/CursosCompartidosPage';
import CarrerasCompartidasPage from './components/Lms/Components/Catalogos/CarrerasCompartidas/CarrerasCompartidasPage';

import IntranetComunicacionDashboardPage from './components/Intranet/Pages/IntranetComunicacionDashboardPage';
import IntranetComunicacionNoticiasPage from './components/Intranet/Pages/IntranetComunicacionNoticiasPage';
import IntranetComunicacionArticulosPage from './components/Intranet/Pages/IntranetComunicacionArticulosPage';
import IntranetComunicacionForosPage from './components/Intranet/Pages/IntranetComunicacionForosPage';
import IntranetComunicacionAvisosPage from './components/Intranet/Pages/IntranetComunicacionAvisosPage';
import IntranetComunicacionBuzonPage from './components/Intranet/Pages/IntranetComunicacionBuzonPage';
import IntranetComunicacionCalendarioPage from './components/Intranet/Pages/IntranetComunicacionCalendarioPage';
import IntranetComunicacionDocumentosPage from './components/Intranet/Pages/IntranetComunicacionDocumentosPage';
import IntranetComunicacionEncuestasPage from './components/Intranet/Pages/IntranetComunicacionEncuestasPage';

import IntranetUsuarioDashboardPage from './components/Intranet/Pages/IntranetUsuarioDashboardPage';
import IntranetUsuarioNoticiasPage from './components/Intranet/Pages/IntranetUsuarioNoticiasPage';
import IntranetUsuarioArticulosPage from './components/Intranet/Pages/IntranetUsuarioArticulosPage';
import IntranetUsuarioForosPage from './components/Intranet/Pages/IntranetUsuarioForosPage';
import IntranetUsuarioAvisosPage from './components/Intranet/Pages/IntranetUsuarioAvisosPage';
import IntranetUsuarioSugerenciasPage from './components/Intranet/Pages/IntranetUsuarioSugerenciasPage';
import IntranetUsuarioCalendarioPage from './components/Intranet/Pages/IntranetUsuarioCalendarioPage';
import IntranetUsuarioDocumentosPage from './components/Intranet/Pages/IntranetUsuarioDocumentosPage';
import IntranetUsuarioEncuestasPage from './components/Intranet/Pages/IntranetUsuarioEncuestasPage';

// LMS Pages

import LmsCoursesPanel from './components/Lms/Pages/CoursesPanel';
import LmsMisCursos from './components/Lms/Pages/MisCursos';
import LmsMisCarreras from './components/Lms/Pages/MisCarreras';
import LmsMisCertificados from './components/Lms/Pages/MisCertificados';
import LmsTiendaPremios from './components/Lms/Pages/TiendaPremios';
import LmsCourseCurriculum from './components/Lms/Pages/CourseCurriculum';
import LmsCourseCurriculumStudent from './components/Lms/Pages/CourseCurriculumStudent';
import CarreraCurriculumStudent from './components/Lms/Pages/CarreraCurriculumStudent';
import LmsCoursePlayerStudent from './components/Lms/Pages/CoursePlayerStudent';
import LmsCoursePlayerPreview from './components/Lms/Pages/CoursePlayerPreview';
import LmsCourseCurriculumReview from './components/Lms/Pages/CourseCurriculumReview';
import LmsCoursePlayerReview from './components/Lms/Pages/CoursePlayerReview';
import LmsCoursePlayerReviewView from './components/Lms/Pages/CoursePlayerReviewView';
import LmsCourseCurriculumReviewView from './components/Lms/Pages/CourseCurriculumReviewView';
import LmsCoursesMarketplace from './components/Lms/Pages/CoursesMarketplace';
import LmsCarrerasMarketplace from './components/Lms/Pages/CarrerasMarketplace';
import EditarCuestionario from './components/Lms/Pages/EditarCuestionario';
import EditarExamen from './components/Lms/Pages/EditarExamen';
import LmsCuestionariosCursos from './components/Lms/Pages/CuestionariosCursos';
import LmsCuestionarios from './components/Lms/Pages/Cuestionarios';
import LmsCuestionarioPreguntas from './components/Lms/Pages/CuestionarioPreguntas';

import LmsAssignEvaluations from './components/Lms/Pages/AssignEvaluations';
import LmsDashboardGeneral from './components/Lms/Pages/DashboardGeneral';
import CarreraCurriculum from './components/Lms/Pages/CarreraCurriculum';
import CarreraCurriculumView from './components/Lms/Pages/CarreraCurriculumView';

import LmsSettingsGeneral from './components/Lms/Settings/SettingsGeneral';
import LmsSettingsAvatar from './components/Lms/Settings/SettingsAvatar';
import LmsSettingsCover from './components/Lms/Settings/SettingsCover';
import LmsSettingsPassword from './components/Lms/Settings/SettingsPassword';

// Sistema Pages
import SistemaPanel from './components/Sistema/Pages/SistemaPanel';
import ColoresPage from './components/Sistema/Pages/ColoresPage';
import LogosPage from './components/Sistema/Pages/LogosPage';
import ImagenesPage from './components/Sistema/Pages/ImagenesPage';
import VisualDesignerPage from './components/Sistema/Pages/VisualDesignerPage';
import ImportacionMasivaPage from './components/Sistema/Pages/ImportacionMasivaPage';

import '@fortawesome/fontawesome-free/css/all.min.css';
import { SessionTimeoutHandler } from './utils/SessionTimeoutHandler';

export default function App() {
  return (
    <SessionTimeoutHandler>
      <Routes>
        {/* Públicas / generales */}
        <Route path="/" element={<FrontSigmaKey />} />
        <Route path="/login" element={<LoginSigmaKey />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/panel" element={<PanelSigmaKey />} />
        <Route path="/lessons" element={<Lessons />} />
        <Route path="/organigrama" element={<Organigrama />} />

        {/* Módulo de seguridad (puede vivir fuera del shell) */}
        <Route path="/roles" element={<RolesPage />} />
        <Route path="/modulos" element={<ModulosPage />} />
        <Route path="/menus" element={<MenusPage />} />



        {/* ====== PANEL SIGMA (con subpaneles) ====== */}
        <Route path="/menu" element={<SigmaShell />}>
          {/* Panel principal (tarjetas de módulos) */}
          <Route index element={<MainModulesPanel />} />

          {/* Seguridad / Matriz */}
          <Route path="seguridad/matriz-permisos" element={<RolesRecursosPermisosMatrix />} />

          {/* Subpanel de Car Booking */}
          <Route path="car-booking" element={<CarBookingPanel />} />

          {/* ===== Car Booking dentro del marco SigmaShell ===== */}
          {/* Dashboard de Reservas */}
          <Route path="car-booking/reservas" element={<Reservation />} />

          {/* Dashboard del chofer */}
          <Route path="car-booking/chofer" element={<Chofer />} />

          {/* Bandeja RH */}
          <Route path="car-booking/rh" element={<RHReviewPage />} />

          {/* (Opcionales) accesos directos a calendario y mapa */}
          <Route path="car-booking/calendar" element={<Calendar />} />
          <Route path="car-booking/maps" element={<Maps />} />
          <Route path="car-booking/checklist-viaje" element={<ChecklistViajePage />} />

          {/* ===== LMS dentro del marco SigmaShell ===== */}
          {/* Panel selector de LMS */}
          <Route path="lms" element={<LmsPanel />} />
          <Route path="lms/carreras" element={<CarrerasPage />} />
          <Route path="lms/semestres" element={<SemestresPage />} />
          <Route path="lms/estudiantes" element={<EstudiantesPage />} />
          <Route path="lms/estadisticas" element={<EstadisticasPage />} />
          <Route path="lms/dashboard-general" element={<LmsDashboardGeneral />} />
          <Route path="lms/progreso" element={<ProgresoEstudiantesPage />} />
          <Route path="lms/administrar-cursos" element={<AdministrarCursosPage />} />
          <Route path="lms/administrar-carreras" element={<AdministrarCarrerasPage />} />
          <Route path="lms/cursos-compartidos" element={<CursosCompartidosPage />} />
          <Route path="lms/carreras-compartidas" element={<CarrerasCompartidasPage />} />
          <Route path="lms/asignar-cursos-estudiantes" element={<AsignarCursosEstudiantesPage />} />
          <Route path="lms/asignar-cursos-area" element={<AsignarCursosAreaPage />} />
          <Route path="lms/asignar-cursos-puesto" element={<AsignarCursosPuestoPage />} />
          <Route path="lms/asignar-cursos-turno" element={<AsignarCursosTurnoPage />} />
          <Route path="lms/lecciones" element={<Lessons />} />
          <Route path="lms/cursos" element={<LmsCoursesPanel />} />
          <Route path="lms/mis-cursos" element={<LmsMisCursos />} />
          <Route path="lms/mis-carreras" element={<LmsMisCarreras />} />
          <Route path="lms/mis-certificados" element={<LmsMisCertificados />} />
          <Route path="lms/tienda-premios" element={<LmsTiendaPremios />} />
          <Route path="lms/catalogo-cursos" element={<LmsCoursesMarketplace />} />
          <Route path="lms/catalogo-carreras" element={<LmsCarrerasMarketplace />} />
          <Route path="lms/curso/:slug" element={<LmsCourseCurriculum />} />
          <Route path="lms/carrera/:id" element={<CarreraCurriculum />} />
          <Route path="lms/carrera-estudiante/:id" element={<CarreraCurriculumStudent />} />
          <Route path="lms/curso-estudiante/:slug" element={<LmsCourseCurriculumStudent />} />
          <Route path="lms/curso-estudiante/:slug/player/:lessonId" element={<LmsCoursePlayerStudent />} />
          <Route path="lms/curso-preview/:slug/player/:lessonId" element={<LmsCoursePlayerPreview />} />
          <Route path="lms/cuestionario/:cuestionarioId/preguntas" element={<EditarCuestionario />} />
          <Route path="lms/examen/:examenId/preguntas" element={<EditarExamen />} />
          <Route path="lms/cuestionarios" element={<LmsCuestionariosCursos />} />
          <Route path="lms/cuestionarios/:courseId" element={<LmsCuestionarios />} />
          <Route path="lms/cuestionarios/:courseId/:id" element={<LmsCuestionarioPreguntas />} />
          <Route path="lms/asignar-evaluaciones" element={<LmsAssignEvaluations />} />
          <Route path="lms/ajustes/general" element={<LmsSettingsGeneral />} />
          <Route path="lms/ajustes/avatar" element={<LmsSettingsAvatar />} />
          <Route path="lms/ajustes/portada" element={<LmsSettingsCover />} />
          <Route path="lms/ajustes/portada" element={<LmsSettingsCover />} />
          <Route path="lms/ajustes/contrasena" element={<LmsSettingsPassword />} />

          {/* Rutas de revisión para Admin LMS */}
          <Route path="lms/curso-curriculo-revision/:idCurso" element={<LmsCourseCurriculumReview />} />
          <Route path="lms/curso-curriculo-revision-view/:idCurso" element={<LmsCourseCurriculumReviewView />} />
          <Route path="lms/carrera-curriculo-revision/:id" element={<CarreraCurriculumView />} />
          <Route path="lms/curso-player-revision/:idCurso/:moduleId/:contentId/:contentType" element={<LmsCoursePlayerReview />} />
          <Route path="lms/curso-player-revision-view/:idCurso/:moduleId/:contentId/:contentType" element={<LmsCoursePlayerReviewView />} />

          {/* ===== Reportes dentro del marco SigmaShell ===== */}
          <Route path="reportes" element={<ReportesPanel />} />
          <Route path="reportes/reservas" element={<ReportesReservasPage />} />
          <Route path="reportes/lms-dashboard" element={<LmsDashboardGeneral />} />
          <Route path="reportes/lms-progreso" element={<ProgresoEstudiantesPage />} />
          <Route path="reportes/lms-estadisticas" element={<EstadisticasPage />} />

          {/* ===== Intranet dentro del marco SigmaShell ===== */}
          <Route path="intranet" element={<IntranetPanel />} />

          <Route path="intranet/comunicacion" element={<IntranetComunicacionDashboardPage />} />
          <Route path="intranet/comunicacion/dashboard" element={<IntranetComunicacionDashboardPage />} />
          <Route path="intranet/comunicacion/noticias" element={<IntranetComunicacionNoticiasPage />} />
          <Route path="intranet/comunicacion/articulos" element={<IntranetComunicacionArticulosPage />} />
          <Route path="intranet/comunicacion/foros" element={<IntranetComunicacionForosPage />} />
          <Route path="intranet/comunicacion/avisos" element={<IntranetComunicacionAvisosPage />} />
          <Route path="intranet/comunicacion/buzon" element={<IntranetComunicacionBuzonPage />} />
          <Route path="intranet/comunicacion/calendario" element={<IntranetComunicacionCalendarioPage />} />
          <Route path="intranet/comunicacion/gestorDocumentos" element={<IntranetComunicacionDocumentosPage />} />
          <Route path="intranet/comunicacion/encuestas" element={<IntranetComunicacionEncuestasPage />} />

          <Route path="intranet/usuario" element={<IntranetUsuarioDashboardPage />} />
          <Route path="intranet/usuario/noticias" element={<IntranetUsuarioNoticiasPage />} />
          <Route path="intranet/usuario/articulos" element={<IntranetUsuarioArticulosPage />} />
          <Route path="intranet/usuario/foros" element={<IntranetUsuarioForosPage />} />
          <Route path="intranet/usuario/avisos" element={<IntranetUsuarioAvisosPage />} />
          <Route path="intranet/usuario/sugerencias" element={<IntranetUsuarioSugerenciasPage />} />
          <Route path="intranet/usuario/calendario" element={<IntranetUsuarioCalendarioPage />} />
          <Route path="intranet/usuario/documentos" element={<IntranetUsuarioDocumentosPage />} />
          <Route path="intranet/usuario/encuestas" element={<IntranetUsuarioEncuestasPage />} />

          {/* Ruta para cargar cualquier catálogo dinámicamente: /menu/dynamic?path=... */}
          <Route path="dynamic" element={<DynamicCatalogPage />} />

          {/* ===== RH dentro del marco SigmaShell ===== */}
          <Route path="rh" element={<RHPanel />} />
          <Route path="rh/organigrama" element={<Organigrama />} />

          {/* ===== Configuración dentro del marco SigmaShell ===== */}
          <Route path="configuracion" element={<ConfiguracionPanel />} />

          {/* ===== Sistema dentro del marco SigmaShell ===== */}
          <Route path="sistema" element={<SistemaPanel />} />
          <Route path="sistema/colores" element={<ColoresPage />} />
          <Route path="sistema/logos" element={<LogosPage />} />
          <Route path="sistema/imagenes" element={<ImagenesPage />} />
          <Route path="sistema/designer" element={<VisualDesignerPage />} />
          <Route path="sistema/importacion" element={<ImportacionMasivaPage />} />

          {/* Fallback dentro de /menu: vuelve al panel principal */}
          <Route path="*" element={<Navigate to="/menu" replace />} />
        </Route>

        {/* Fallback global */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </SessionTimeoutHandler>
  );
}
